import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ImageBackground } from 'react-native';
import { Svg, Path } from 'react-native-svg';
import { Meeting } from '@/types/meetings';
import { useLanguage } from '@/contexts/LanguageContext';
import { getMeetingDisplayTime } from '@/utils/meetingUtils';

interface MeetingListCardProps {
  meeting: Meeting;
  onPress: () => void;
}

export default function MeetingListCard({ meeting, onPress }: MeetingListCardProps) {
  const { t } = useLanguage();
  const { displayText } = getMeetingDisplayTime(meeting.meeting_time, meeting.meeting_weekday, t);

  return (
    <TouchableOpacity style={styles.card} onPress={onPress} activeOpacity={0.7}>
      <View style={styles.imageContainer}>
        <ImageBackground
          source={require('../assets/images/image_1763325486152.png')}
          style={styles.image}
          imageStyle={styles.imageStyle}
        />
      </View>
      <View style={styles.content}>
        <Text style={styles.title} numberOfLines={2}>{meeting.meeting_name}</Text>
        <View style={styles.timeRow}>
          <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <Path d="M10.1016 2.46143V4.44497" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <Path d="M5.28516 2.46143V4.44497" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <Path fillRule="evenodd" clipRule="evenodd" d="M10.4566 3.37598L4.94039 3.37652C3.32005 3.37652 2.30859 4.27884 2.30859 5.93735V10.9302C2.30859 12.6149 3.32005 13.5381 4.94039 13.5381L10.4519 13.5376C12.077 13.5376 13.0837 12.6305 13.0837 10.9714V5.9368C13.0885 4.27829 12.0817 3.37598 10.4566 3.37598Z" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <Path d="M5.01562 7.625H5.02229" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <Path d="M5.01562 9.92773H5.02229" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <Path d="M7.69141 7.625H7.69807" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <Path d="M7.69141 9.92773H7.69807" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <Path d="M10.3594 7.625H10.366" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <Path d="M10.3594 9.92773H10.366" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </Svg>
          <Text style={styles.timeText}>{displayText}</Text>
        </View>
      </View>
      <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path d="M6 3L11 8L6 13" stroke="#A19F97" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </Svg>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 24,
  },
  imageContainer: {
    width: 64,
    height: 64,
    borderRadius: 12,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#F0EEE4',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  imageStyle: {
    resizeMode: 'cover',
  },
  content: {
    flex: 1,
    gap: 4,
  },
  title: {
    fontSize: 16,
    fontFamily: 'Inter',
    fontWeight: 'bold',
    color: '#151515',
    lineHeight: 22.4,
  },
  timeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  timeText: {
    fontSize: 12,
    fontFamily: 'Inter_500Medium',
    color: '#7E7D75',
    lineHeight: 12,
  },
});
